// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"104":"0f194269","161":"0f194269","351":"63ec8aab","582":"fd87927c","961":"0f194269"}[chunkId] + ".chunk.css");